/* eslint camelcase: 0, no-unused-expressions: 0 */

import React from 'react';
import get from 'lodash/get';
import findKey from 'lodash/findKey';
import { FormBuilder } from '../forms/form';
import { Helpers } from '../helpers/helpers';
import { TosCTAdisclaimer } from '../terms/cta-disclaimer';
import { BootstrapModal } from '../modal/bootstrap-modal';
import CheckboxField from '../reduxForms/fields/CheckboxField/CheckboxField';
import Cookie from 'react-cookie';
import { SignupErrors, handleError } from '../nextjs/auth/signup/SignupManager/signup-errors';

export class SignupLiteModal extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      errorMsg: ''
    };
    this.checkGrants = this.checkGrants.bind(this);
    this.checkGrantsCb = this.checkGrantsCb.bind(this);
    this.signinCb = this.signinCb.bind(this);
    this.inputRefs = React.createRef();
    this.handleInputOnChange = this.handleInputOnChange.bind(this);
  }

  handleInputOnChange () {
    const fields = ['firstName', 'lastName', 'signupEmail', 'signupPassword'];
    const hasError = fields.some(field => get(this.inputRefs, `current.formRefs["${field}"].state.error.inputBorder`, '') === 'error');

    if (hasError) {
      this.inputRefs.current.inputsValid();
    }
  }

  checkGrants (e, callback, ref, values) {
    const { checkGrantsAction } = this.props;
    const username = values.email;
    const password = values.password;
    const firstName = values.first_name;
    const lastName = values.last_name;
    const emailOptOut = document.getElementById('email_opt_out').checked;
    /* pre sign-up, regardless of other entitlements,
       we will attribute the tastemaker here
       if a user has been on their page */
    const promoId = PSSessions.Cookies('tm_ent') || PSSessions.Cookies('promo-id');
    const attrUrl = PSSessions.Cookies('PSAttrUrl');
    const attrRef = PSSessions.Cookies('PSAttrReferrer');
    const forterToken = window.fcToken || PSSessions.Cookies('forterToken');
    const locale = Cookie.load('preferred_locale') || Cookie.load('initial_locale');

    // unsubscribe in vero will not work in alpha/beta due to a
    // segment alias call to vero that is only filtered out for prod
    const profileBody = {
      username,
      password,
      first_name: firstName,
      last_name: lastName,
      ga_client_id: analyticsIntegrations.getGoogleAnalyticsID(),
      attr_url: attrUrl,
      attr_referrer: attrRef,
      unsubscribe: emailOptOut,
      ...(locale && { preferred_locale: locale }),
      forterTokenCookie: forterToken
    };

    Cookie.save('preferred_locale', locale, {
      path: '/',
      expires: new Date((Date.now()) + (60 * 60 * 6 * 1000)),
      domain: window.location.host,
      secure: -1 !== window.location.protocol.indexOf('s')
    });


    if (promoId) profileBody.entitlement_id = promoId;
    return checkGrantsAction(username, profileBody, callback);
  }

  checkGrantsCb (res, profileBody) {
    const provider = findKey(res, value => true === value);
    const { signupAction, signinAction } = this.props;
    if (res.error || 400 < res.statusCode) {
      return this.setState({ errorMsg: 'Something went wrong. Please refresh and try again later.' });
    }
    if (res.google || res.facebook || res.apple) {
      return this.setState({ errorMsg: SignupErrors(provider) });
    }
    if (res.email) {
      return signinAction(profileBody.username, profileBody.password, this.signinCb, profileBody);
    }
    signupAction(profileBody, (response) => {
      return this.signupCb(profileBody, response);
    });
  }

  signupCb ({ username, password, ...profileDetails }, response) {
    if (response.error) {
      const errorDescription = get(response, 'error_description', '').length ? get(response, 'error_description', '') : get(response, 'error_description.message', '');
      const statusCode = get(response, 'statusCode', '');
      if (400 < statusCode || 'Invalid JSON' === errorDescription) {
        return this.setState({ errorMsg: handleError(errorDescription || '') });
      }
      if ('Invalid Password' === errorDescription) {
        return this.setState({ errorMsg: handleError(errorDescription || '') });
      }
      if ('Username in use' === errorDescription) {
        this.props.signinAction(username, password, this.signinCb, profileDetails);
      } else {
        // will catch any errors that weren't logged originally throwing our general 'something went wrong' error
        return this.setState({ errorMsg: SignupErrors() });
      }
    } else {
      if (window && response.SSOid) {
        Helpers.setCookies(response);
      }
      // Render profile modal
      return this.props.signupActionCb(response, { username, ...profileDetails });
    }
  }

  signinCb (response) {
    if (response.error) {
      const errorDescription = get(response, 'error_description', '').length ? get(response, 'error_description', '') : get(response, 'error_description.message', '');
      if (400 < response.statusCode || 'Invalid JSON' === errorDescription) {
        return this.setState({ errorMsg: handleError(errorDescription || '') });
      }
      return this.setState({ errorMsg: handleError(errorDescription || '') });
    }
    if (window && response.SSOid) {
      Helpers.setCookies(response);
    }
    analyticsIntegrations.accountLogin(response.SSOid);
    return this.props.signinActionCb(response);
  }

  trackLinkClick () {
    analyticsIntegrations.trackLinkClick('login link on sign up form');
  }

  userNameInUseError () {
    return (
      <p className="text-left">
      This email is already taken.&nbsp;
        <a href="#a=login" onClick={this.trackLinkClick}>Login</a>
        <span className="text-gray-dark">&nbsp;or&nbsp;</span>
        <a href="/app/password-reset">reset your password</a>
        <span className="text-gray-dark">.</span>
      </p>
    );
  }

  formBuilder () {
    const defaultEmail = get(this.props, ['action_store', 'invite_data', 'email'], '');
    return (
      <div>
        <FormBuilder
          ref={this.inputRefs}
          formname="signup form"
          formStyle="modal"
          formInputs={
            [
              {
                inputFieldName: 'first_name',
                elementID: 'first_name',
                ref: 'firstName',
                optional: false,
                defaultVal: null,
                onChange: () => this.handleInputOnChange()
              },
              {
                inputFieldName: 'last_name',
                elementID: 'last_name',
                ref: 'lastName',
                optional: false,
                defaultVal: null,
                onChange: () => this.handleInputOnChange()
              },
              {
                inputFieldName: 'email',
                elementID: 'signup_email',
                optional: false,
                ref: 'signupEmail',
                defaultVal: defaultEmail,
                onChange: () => this.handleInputOnChange()
              },
              {
                inputFieldName: 'password',
                elementID: 'signup_password',
                optional: false,
                ref: 'signupPassword',
                onChange: () => this.handleInputOnChange()
              }
            ]
          }
          submitAction={this.checkGrants}
          submitCallback={this.checkGrantsCb}
          buttonText="Sign Up"
          errorText={this.state.errorMsg}
          afterCTA={
            <div className="gutter text-left">
              <TosCTAdisclaimer buttonLabel="Sign Up" location="signup" />
              <hr className="full-width gutter"/>
              <p className="text-small">Peerspace will send you deals, inspiration, and marketing emails. You can opt out at any time from your account settings.</p>
              <CheckboxField
                id="email_opt_out"
                label={<div className="text-small">I don’t want to receive marketing emails from Peerspace.</div>}
              />
            </div>
          }
        />
      </div>
    );
  }

  render () {
    const { location = {}, useSearchQuery } = this.props;
    const pathname = `${location.pathname}${useSearchQuery ? location.search : ''}` || '';
    const redirectLocation = pathname ? `?dest=${encodeURIComponent(pathname)}` : '';

    return (
      <BootstrapModal
        {...this.props}
        modalClass="profile-lite-modal"
        header={
          this.props.header || <h3>Sign up to vote and comment on or copy this board</h3>
        }
        body={this.formBuilder()}
        footer={
          <div>
            <p className="login-link subform-text text-center">
              Already have an account?&nbsp; <a href={`/signin${redirectLocation}`}>Log In</a>
            </p>
          </div>
        }
      />
    );
  }
}
